import { useQuery } from "@tanstack/react-query";
import { apiV2 } from "api/firebase";
import useInvalidateOnShowNotifications from "hooks/useInvalidateOnShowNotifications";
import { STAND_REALTIME_KEYS, standsQueryKey } from "./standQueries";

type UseStandsCountResult = [number | undefined, boolean];

const useStandsCount = (showId?: string): UseStandsCountResult => {
  const { data, isFetching } = useQuery({
    queryKey: [...standsQueryKey(showId), "count"],
    queryFn: async () => {
      const { meta } = await apiV2.stand.getPaginated({
        showId: showId as string,
        limit: 1,
      });

      return meta.totalItems ?? 0;
    },
    enabled: !!showId,
    refetchOnWindowFocus: false,
  });

  useInvalidateOnShowNotifications({
    showId,
    keys: STAND_REALTIME_KEYS,
    queryKey: standsQueryKey(showId),
  });

  return [data, isFetching];
};

export default useStandsCount;
